import { render } from "./AdvisorColumnManagerDrawer.vue?vue&type=template&id=ca7e9dd2&scoped=true"
import script from "./AdvisorColumnManagerDrawer.vue?vue&type=script&lang=js"
export * from "./AdvisorColumnManagerDrawer.vue?vue&type=script&lang=js"

import "./AdvisorColumnManagerDrawer.vue?vue&type=style&index=0&id=ca7e9dd2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca7e9dd2"]])

export default __exports__